// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"PostSocialLinks--socialLinks--vWWrp","copyToClipboard":"PostSocialLinks--copyToClipboard--iomx2"};